import { z } from 'zod';

export const SubsystemSchema = z.object({
  id: z.string().min(1),
  project_id: z.string().min(1),
  slug: z
    .string()
    .min(1)
    .regex(/^[a-z0-9-]+$/), // url-safe
  name: z.string().min(1),
  description: z.string().nullable(),
  color: z
    .string()
    .regex(/^#[0-9a-f]{6}$/i)
    .nullable(), // for canvas tinting
  icon: z.string().nullable(),
  archived_at_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
});

export type ParsedSubsystem = z.infer<typeof SubsystemSchema>;
